Util = require 'app/scripts/lib/util'
DragSort = require 'app/scripts/views/lib/drag-sort'
log = require 'app/scripts/debug/log'

module.exports.openListComposer = ->
  @model.viewState.openListComposer()

module.exports.scrollToList = (list) ->
  Util.scrollElementIntoView @$('#board')[0], @viewForList(list).el,
    horizontal: true
    animated: true
  return

module.exports.viewForList = (list) ->
  return @listListView.viewForModel(list)

module.exports.postListListRender =  ->
  log('render', "rendering inline composer and calculating list layout")
  @renderFilteringStatus()
  @renderInspirationPopover()
  DragSort.refreshListCardSortable()

module.exports.renderLists = ->
  @listListView.$el.toggleClass 'js-list-sortable', @model.editable()
  @$('.board-canvas').append @listListView.el
  # Render after adding because postListListRender is dumb and wants the
  # #board element to be in the DOM already
  @listListView.render()
  @listListView.delegateEvents()
  @

module.exports.sortCommit = (e, ui) ->
  ui.item.trigger 'movelist', ui
